import React, { useState,useEffect } from 'react';
import { Field, FieldWrapper} from '@progress/kendo-react-form';
import {CusFormComboBox, FormSubTitle} from '../validation/Form-Components';
import { reqDDLValidator} from '../validation/Validators';
import appDetailsData from '../data/persondetailsdata.json';
import titles from '../data/titles.json';
import marStatusArray from '../data/maritalstatus.json';
import helper from '../factory/Helper.js';
import { filterBy } from "@progress/kendo-data-query";
import countriesDomicile from '../data/domicilecountries.json';
import PersonContactDetails from '../components/PersonContactDetails';
import PersonResiAddress from '../components/PersonResiAddress';
import PersonIncomeCPF from '../components/PersonIncomeCPF';
import PersonCPFHistory from '../components/PersonCPFHistory';
import storage from '../factory/StorageFactory';
 

const AuthPerson = (props) => {

    const{seq, applicantDetails, hasMyInfo, formRenderProps, cpfHistory,yrOfAssessment, holders, showAuthPerDDL} = props;
    
    const [fCountries, setfCountries] = useState(countriesDomicile.slice());  //filtered countries

    useEffect(() => {
        console.log('@AuthPerson useEffect: ');
        if(hasMyInfo && storage.getIsAPSavedForm() === 'false'){
            formRenderProps.onChange('marStatusCbo'+seq, { value: helper.getObjInArray(applicantDetails.myInfo.MaritalStatusCode,marStatusArray)});
        }
    }, []);
 
 
    const filterData = (filter) => {
        const data = countriesDomicile.slice();
        return filterBy(data, filter);
    };
    
    const filterChange = (event) => {
        setfCountries(filterData(event.filter));
    };

    return(
        <div>
            {hasMyInfo?
            <div>
                <Field leftLabelId={'lblTitle'+seq} leftLabelName={appDetailsData.titleDDL.lblname}
                    id={'titleCbo'+seq} name={'titleCbo'+seq}
                    component={CusFormComboBox} textField={'label'}
                    disabled={!applicantDetails.allowEdit}
                    data={titles} placeholder={'Please select'} validator={reqDDLValidator} />

                <Field leftLabelId={'lblMarStatus'+seq} leftLabelName={appDetailsData.marStatusDDL.lblname}
                    id={'marStatusCbo'+seq} name={'marStatusCbo'+seq}
                    component={CusFormComboBox} 
                    textField={'label'}
                    data={marStatusArray} 
                    dataItemKey="value"
                    disabled={!applicantDetails.allowEdit}
                    value={appDetailsData.marStatusDDL} 
                    placeholder={'Please select'}
                    validator={reqDDLValidator}/>

                <Field leftLabelId={'lblCouOfDom'} leftLabelName={appDetailsData.label.countryOfDom}
                    id={'countOfDomicileCbo'+seq} name={'countOfDomicileCbo'+seq}
                    component={CusFormComboBox}
                    textField={'label'}
                    disabled={!applicantDetails.allowEdit}
                    data={fCountries}
                    filterable={true}
                    onFilterChange={filterChange}
                    placeholder={'Please select'}
                    validator={reqDDLValidator} />
                
                <div style={{paddingTop: "15px"}}> <hr className="greyPanelLine"/> </div>
 
                <PersonContactDetails seq={seq} fProps={formRenderProps} disabled={!applicantDetails.contactDtlEdit}  />

                <div style={{ paddingTop: "15px" }}> <hr className="greyPanelLine" /> </div>

                <Field component={FormSubTitle} id={'fstResidentialAddress'+seq} name={appDetailsData.formSubTitle.ST2} />

                <PersonResiAddress seq={seq} applicantDetails={applicantDetails}  />
      
                {(applicantDetails.showCPFAndNOA)&&
                <div>
                    <div style={{ paddingTop: "15px" }}> <hr className="greyPanelLine" /> </div>
                    <Field component={FormSubTitle} id={'fstResidentialAddress'+seq} name={appDetailsData.formSubTitle.ST3} />
                    <PersonIncomeCPF data={yrOfAssessment} /> 
                    <PersonCPFHistory minData={cpfHistory.minData} maxData={cpfHistory.maxData} />
                </div>
                }
                {(storage.getIsFProdBTL() === 't')&& <>
                <div style={{ paddingTop: "20px" }}> <hr className="greyPanelLine" /> </div>
                <FieldWrapper>
                    <Field component={FormSubTitle} id={'fstMHInstallment'+seq} name={appDetailsData.formSubTitle.ST4} />
                    <Field leftLabelId={'lblMHLoanInstallment'} leftLabelName={appDetailsData.label.mhLoanInstallment}
                        id={'mhLoanInstallmentCbo'+seq} name={'mhLoanInstallmentCbo'+seq}
                        component={CusFormComboBox}
                        textField={'label'}
                        disabled={!applicantDetails.allowEdit}
                        data={appDetailsData.mhLoanInstallmentData}
                        placeholder={'Please select'}
                        validator={reqDDLValidator} />
                </FieldWrapper></>
                }
                <FieldWrapper></FieldWrapper>
        </div> :
        <PersonContactDetails seq={seq} fProps={formRenderProps} disabled={!applicantDetails.allowEdit} holders={holders} showAuthPerDDL={showAuthPerDDL} />
        }
       
        </div>
    )
}

export default AuthPerson;